import styled, { StyledComponent } from 'styled-components';

export const Container: StyledComponent<'div', any> = styled.div`
  padding-bottom: 24px;
  width: 450px;
  max-height: 400px;
  overflow-y: auto;

  color: rgba(0, 0, 0, 0.88);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.12px;
`;

export const Header: StyledComponent<'div', any> = styled.div`
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 4px;

  font-weight: 500;
`;

export const Body: StyledComponent<'div', any> = styled.div`
  padding: 0 16px;
`;

export const Footer: StyledComponent<'div', any> = styled.div`
  display: flex;
  padding: 8px 16px 16px 16px;
  flex-direction: column;
  justify-content: center;
`;

export const EventNameValueWrapper = styled.div`
  display: flex;
`;

export const Name: StyledComponent<'div', any> = styled.div`
  display: flex;
  min-width: 115px;
  padding: 4px 0 4px 8px;
`;

export const Value = styled.div`
  display: flex;
  min-width: 100px;
  padding: 4px 8px;
  flex: 1 0 0;
`;

export const RulesBuilderContainer: StyledComponent<'div', any> = styled.div`
  color: rgba(0, 0, 0, 0.45);
  text-align: right;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.12px;

  margin-top: 4px;
  gap: 8px;
  display: flex;
  flex-direction: column;

  overflow: scroll;
`;

export const EventNameWrapper = styled.div`
  display: flex;
  align-items: center;

  border-top: 1px solid rgba(0, 0, 0, 0.15);
  background: #f5f5f5;
`;

export const MappingRulesContainer: StyledComponent<'div', any> = styled.div`
  margin-left: 46px;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const MappingRules: StyledComponent<'div', any> = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px 0;
`;

const ruleTagStyles = `
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.11px;
  text-align: center;
`;

export const ORTag = styled.div`
  ${ruleTagStyles};
  color: rgba(0, 0, 0, 0.45);

  width: 32px;
  height: 16px;
`;

export const ANDTag = styled.div`
  ${ruleTagStyles};
  font-weight: 500;
  color: rgba(0, 0, 0, 0.45);
  width: 40px;
  height: 16px;
`;

export const FooterTitle: StyledComponent<'div', any> = styled.div`
  padding: 12px 8px 4px 8px;
  border-top: 1px solid #d9d9d9;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
`;
export const ANDLine: StyledComponent<'div', any> = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  margin: 8px 0;
  position: relative;
  ::after {
    content: 'AND';
    position: absolute;
    top: -8px;
    left: 15%;
    transform: translateX(-50%);
    padding: 0 8px;
    color: rgba(0, 0, 0, 0.45);
    background-color: #fff;
  }
`;
